import { render, staticRenderFns } from "./tr-prod.vue?vue&type=template&id=dc3c3cfe&scoped=true"
import script from "./tr-prod.vue?vue&type=script&lang=js"
export * from "./tr-prod.vue?vue&type=script&lang=js"
import style0 from "./tr-prod.vue?vue&type=style&index=0&id=dc3c3cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3c3cfe",
  null
  
)

export default component.exports